var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_ab90a1d4"]},_vm.$listeners),[_c('cube-button',{attrs:{"light":"","active":""}},[_vm._v("light")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }